// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: 'pdv/powerbi',
  component: () => import('modules/powerbi/Index.vue'),
  children: [
    {
      path: 'pdvcapilaridade',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'PDV',
            name: 'PDV'
          },
          {
            text: 'Capilaridade',
            name: 'PDVCapilaridade'
          }
        ]
      },
      name: 'PDVCapilaridade',
      component: () => import('modules/powerbi/PDVCapilaridade'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.pdv.retail.dashboard.capilaridade')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'pdvfinancial',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'PDV',
            name: 'PDV'
          },
          {
            text: 'KPIs Financeiros',
            name: 'PDVFinancial'
          }
        ]
      },
      name: 'PDVFinancial',
      component: () => import('modules/powerbi/PDVFinancial'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.pdv.retail.dashboard.financeiro')) {
          next();
        } else {
          next('/');
        }
      }
    },
  ]
};
